




































import {
  defineComponent,
  ref,
  computed,
  reactive,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import dayjs from 'dayjs';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import storage from '@/renderer/scripts/utils/storage';
import { IS_DEV, IS_TEST } from '@/common/constant/platform';
import { httpUrl, CONSTANT_URL } from '@/renderer/scripts/http';
import getRequest from '@/renderer/scripts/httpRequest';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

interface AdvertItem {
  position: string;
  startTime: string;
  endTime: string;
}
export default defineComponent({
  name: 'advert',
  props: {
    position: {
      type: String,
      default: '',
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props, context) {
    const { position } = props;
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const swiper = ref(null);
    const isShowAdvert = ref(true);
    const waitRequest = ref(false);
    // 可以使用templateReplace替换的模板
    // const sidebarStr = `
    // <a href="https://pan.tencent.com" target="_blank" style="text-decoration: none;color:inherit">
    //   <div style="position: relative;padding: 10px 10px 0 10px;display: flex;font-size: 12px">
    //     <div>
    //       <div style="font-weight: 600">{{title}}</div>
    //       <div style="color: rgba(0, 0, 0, 0.6)">{{detail}}</div>
    //     </div>
    //     <img src='https://img-blog.csdnimg.cn/1bedc6e9d54647a6ba272a57b4cc63ac.png' alt=""
    //       style="height: 66px;width: 48px; margin: 17px 0 6px 0"/>
    //   </div>
    // </a>
    // `;
    // const FooterStr = `
    // <a href="https://pan.tencent.com" target="_blank" style="text-decoration: none;color:inherit">
    //   <div style="position: relative;padding: 10px 10px 0 10px;display: flex;font-size: 12px">
    //     <div>
    //       <div style="font-weight: 600,font-size:14px">{{title}}</div>
    //       <div style="color: rgba(0, 0, 0, 0.6)">{{detail}}</div>
    //     </div>
    //     <img src='https://img-blog.csdnimg.cn/1bedc6e9d54647a6ba272a57b4cc63ac.png' alt=""
    //       style="height: 100px;width: 100px; margin: 0"/>
    //   </div>
    // </a>
    // `;
    // const adConfig = [
    //   {
    //     title: '对外发送的文件被外传？',
    //     detail: '更安全的安全外链，确保指定的人才可访问文件',
    //   },
    //   {
    //     title: '人员离职项目无法继续？',
    //     detail: '离职人员资料一键转移，项目资料无一遗漏',
    //   },
    //   {
    //     title: '居家办公，资料找不到？',
    //     detail: '本地文档实时同步备份，工作资料随手可得',
    //   },
    //   {
    //     title: '合作资料散落各处？',
    //     detail: '统一的存储空间，随时随地发起协作并汇聚于此',
    //   },
    // ];
    /**
     *  使用方法 templateReplace(sidebarStr,adConfig[0])
     */
    // const templateReplace = (template, context) =>
    //   template.replace(/\{\{(.*?)\}\}/g, (match, key) => context[key.trim()]);
    const searchAvailable = computed(() => vm.$route?.meta?.searchAvailable === true);
    const advert = ref({
      position: '',
      startTime: '',
      endTime: '',
      roll: 0,
    });
    const swiperOptions = reactive({
      loop: true,
      // 循环滚动
      autoplay: {
        disableOnInteraction: false,
        delay: advert.value?.roll * 1000 || 5000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true, // 轮播按钮支持点击
      },
    });

    try {
      const request = getRequest({
        logPrefix: 'Advert',
      });
      waitRequest.value = true;
      // 区分正式和测试环境
      const url = `${httpUrl.webUrl}/api/advertise${IS_DEV || IS_TEST ? '?beta=1' : ''}`;
      request({
        url,
        method: 'get',
      })
        .then(res => {
          const data = res.data as { list: AdvertItem[] };
          data.list.forEach(item => {
            if (item.position && item.position === position) {
              advert.value = { ...item, roll: 0 };
            }
          });
          const flag = storage.get(storage.StoreKey.NOT_SHOW_BANNER_ADVERT);
          const now = dayjs().valueOf();
          const startTime = dayjs(advert.value.startTime).valueOf();
          const endTime = dayjs(advert.value.endTime).valueOf();
          // 只在时间范围内展示,优先级最高
          if (Number(advert.value.startTime) || Number(advert.value.endTime)) {
            if (now > startTime && now < endTime) {
              isShowAdvert.value = !(flag === 'undefined' || !!flag);
            } else {
              isShowAdvert.value = false;
            }
          }
          waitRequest.value = false;
        })
        .catch(e => {
          logger.ui.error(`[GetAdvert] error ${JSON.stringify(e)}`);
        });
    } catch (err) {
      logger.ui.error(`[GetAdvert] error ${JSON.stringify(err)}`);
    }
    const closeAdvert = () => {
      if (position === 'top') {
        context.emit('close');
      } else {
        isShowAdvert.value = false;
        storage.set(storage.StoreKey.NOT_SHOW_BANNER_ADVERT, 'not-show-banner-advert');
      }
    };
    const sourceMap: Record<string, string> = {
      invitation: 'invitelink_banner',
      share: 'sharelink_banner',
    };
    const adClick = (link: string) => {
      link && dispatchRouter(link);
      const routerName = context.root.$route.name as string;
      reporter.report('pay', {
        pay_source_click: sourceMap[routerName] || 'negative_banner',
      });
    };

    // 触发v-html事件 可将事件提取至外部div触发
    const handlerJump = (event: Event) => {
      const target = event?.target as HTMLInputElement | null;
      if (target?.className === 'tips-button') {
        dispatchRouter(CONSTANT_URL.bulletinUrl);
      }
    };
    return {
      swiper,
      advert,
      isShowAdvert,
      handlerJump,
      adClick,
      swiperOptions,
      closeAdvert,
      waitRequest,
      searchAvailable,
    };
  },
});
